import { useMutation } from '@tanstack/react-query';
import { api } from '@app/utils/api';
import { errorHandler } from '@app/utils/errorHandler';
import { ICustomersFilter } from '@pages/Customer/List/filter';
import { ICustomerListItem } from '@entities/customer/ICustomerListItem';
import { BI_BASE_URL } from '@app/contstants/endpoints';
import { format } from 'date-fns';
import { IHostingListItem } from '@entities/hosting/IHostingListItem';
import { IHostingListFilter } from '@pages/Hosting/List/filter';

export interface IHostingList {
  items: IHostingListItem[];
  total_pages: number;
  total_items: number;
  current_page: number;
}

export const fetchData = async (filters: IHostingListFilter): Promise<IHostingList> => {
  let data = {};

  if (filters.sort) {
    data = {
      ...data,
      sort_order: filters.sort.type,
      sort_by: filters.sort.column,
    };
  }

  if (filters.perPage) {
    data = { ...data, page_size: filters.perPage };
  }

  // const response = await api.get<IHostingList>(`${BI_BASE_URL}/clients/`, {
  //     params: {
  //
  //         page: filters.page,
  //         ...data,
  //     },
  // });

  return {
    items: [
      {
        id: 1,
        name: 'Mining Capital',
        status: 'Активен',
        common_power: 70,
        location: 'Сосновоборск',
        nominal_power: 17,
        actual_power: 17,
        percent_of_power: 21,
        free_power: 18,
      },
      {
        id: 2,
        name: 'Mining Capital',
        status: 'Активен',
        common_power: 70,
        location: 'Сосновоборск',
        nominal_power: 17,
        actual_power: 17,
        percent_of_power: 21,
        free_power: 18,
      },
      {
        id: 3,
        name: 'Mining Capital',
        status: 'Активен',
        common_power: 70,
        location: 'Сосновоборск',
        nominal_power: 17,
        actual_power: 17,
        percent_of_power: 21,
        free_power: 18,
      },
      {
        id: 4,
        name: 'Mining Capital',
        status: 'Активен',
        common_power: 70,
        location: 'Сосновоборск',
        nominal_power: 17,
        actual_power: 17,
        percent_of_power: 21,
        free_power: 18,
      },
      {
        id: 5,
        name: 'Mining Capital',
        status: 'Активен',
        common_power: 70,
        location: 'Сосновоборск',
        nominal_power: 17,
        actual_power: 17,
        percent_of_power: 21,
        free_power: 18,
      },
      {
        id: 5,
        name: 'Mining Capital',
        status: 'Активен',
        common_power: 70,
        location: 'Сосновоборск',
        nominal_power: 17,
        actual_power: 17,
        percent_of_power: 21,
        free_power: 18,
      },
    ],
    total_pages: 1,
    total_items: 6,
    current_page: 1,
  };

  // return response.data ?? [];
};

export const useHostingList = () => {
  const { mutateAsync, isError, isPending, isSuccess, error } = useMutation({
    mutationFn: fetchData,
    onError: error => errorHandler(error),
  });

  return {
    fetchData: mutateAsync,
    isError,
    isPending,
    isSuccess,
    error,
  };
};
